import { enUS, nb, pl, sv, uk } from "date-fns/locale";
import { Locales } from "rn-calendar-component";

import { getMonths, getWeekDays, isWeb } from "@stepapp/core";
import { setDefaultOptions } from "date-fns";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../hooks";

export const useSetupApp = () => {
  const { i18n } = useTranslation();
  const appConfigLanguage = useAppSelector(({ appConfig }) => appConfig.pickedLanguage);
  const locales = { pl, enUS, uk, sv, nb };
  const language = useMemo(() => {
    if (appConfigLanguage) return appConfigLanguage;

    if (isWeb) {
      const href = window?.location?.href;
      return href?.includes(".no") ? "no" : href?.includes(".pl") ? "pl" : i18n.language;
    }

    return i18n.language;
  }, [appConfigLanguage, i18n.language]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  useEffect(() => {
    if (appConfigLanguage === i18n.language) return;

    i18n.changeLanguage(language);
  }, [language, appConfigLanguage]);

  const localLanguage = language === "no" ? "nb" : language === "en" ? "enUS" : language;

  // @ts-expect-error
  setDefaultOptions({ locale: locales[localLanguage], weekStartsOn: 1 });

  Locales.pl = {
    monthNames: getMonths("LLLL"),
    monthNamesShort: getMonths("LLL"),
    dayNames: getWeekDays("EEEE", 0),
    dayNamesShort: getWeekDays("E", 0),
  };
};
